/**
 * Single source of truth for locales offered in UI language pickers.
 * Must stay aligned with `resources` in `src/i18n/index.ts`.
 */
export type AppLanguageCode = 'en' | 'et' | 'lv'

export const APP_LANGUAGES: readonly { code: AppLanguageCode; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'et', label: 'Eesti' },
  { code: 'lv', label: 'Latviešu' },
] as const

/** Map i18next / browser codes (e.g. `en-US`) to a registered app locale. */
export function resolveAppLanguageCode(i18nLanguage: string | undefined): AppLanguageCode {
  const raw = (i18nLanguage ?? '').trim() || 'en'
  const exact = APP_LANGUAGES.find((l) => l.code === raw)
  if (exact) return exact.code

  const primary = raw.split('-')[0]?.trim() || 'en'
  const byPrimary = APP_LANGUAGES.find((l) => l.code === primary)
  return byPrimary ? byPrimary.code : 'en'
}

export function appLanguageDisplayLabel(i18nLanguage: string | undefined): string {
  const code = resolveAppLanguageCode(i18nLanguage)
  const row = APP_LANGUAGES.find((l) => l.code === code)
  return row?.label ?? (i18nLanguage?.trim() || code)
}
